var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FFE4E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1722 31.15C23.3462 31.409 23.652 31.5816 24 31.5816C24.348 31.5816 24.6538 31.409 24.833 31.15L30.6432 22.507C31.4235 21.3441 31.877 20.0645 31.877 18.5816C31.8717 14.2957 28.3761 11 24 11C19.6239 11 16.1283 14.2957 16.1283 18.5816C16.1283 20.0645 16.5817 21.3441 17.362 22.507L23.1722 31.15ZM24 14.25C26.4833 14.25 28.4974 16.1898 28.4974 18.5816C28.4974 20.9734 26.4833 22.9133 24 22.9133C21.5167 22.9133 19.5026 20.9734 19.5026 18.5816C19.5026 16.1898 21.5167 14.25 24 14.25ZM29.768 27.4277L24 34.8316L18.232 27.4277C16.2601 28.423 15 29.9109 15 31.5816C15 34.5727 19.0281 37 24 37C28.9719 37 33 34.5727 33 31.5816C33 29.9109 31.7399 28.423 29.768 27.4277Z",
    fill: "#FB7185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.c2296e15ce2dd372ec59b89ee5f3835b.svg";
export { ForwardRef as ReactComponent };